import { Avatar, Divider, Popover, Tab, Tabs, withStyles } from '@material-ui/core';
import { Fragment, useState } from 'react';
import { BsChevronDown } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';

const StyledTabs = withStyles({
	indicator: {
		backgroundColor: 'white',
	},
})(Tabs);

const StyledTab = withStyles({
	root: ({ selected }) => ({
		color: 'black',
		background: selected ? 'rgba(0, 157, 255, .3)' : 'transparent',
		borderRadius: '10px',
		textTransform: 'capitalize',
		minWidth: '125px',
		paddingInline: '10px',
		paddingBlock: '2px',
		minHeight: '3em',
	}),
})(Tab);

const CheckedInList = ({ people, type }) => {
	const navigate = useNavigate();
	const navigateToProfile = (id) => {
		if (type === 'Students') {
			navigate(`/students-student/${id}`);
		} else {
			navigate(`/staff-info/${id}`);
		}
	};
	return (
		<div>
			<div className="my-8 mx-8 mt-4 flex flex-col">
				<Divider className="mb-4" />
				{people.length ? (
					people?.map((person, index) => {
						const isLast = index === people.length - 1;
						return (
							<Fragment key={person.id}>
								<button
									className="flex gap-16 items-center w-full text-left hover:bg-grey-200 px-8 py-4 rounded-md cursor-pointer transition-colors"
									onClick={() => navigateToProfile(person.id)}
									type="button"
								>
									<Avatar className="h-32 w-32" src={person.thumb} />
									<span>
										{person.last_name}, {person.first_name}
									</span>
								</button>
								{!isLast ? <Divider className="my-4" /> : null}
							</Fragment>
						);
					})
				) : (
					<div className="flex items-center justify-center h-full">
						<span className="italic">No {type} </span>
					</div>
				)}
			</div>
		</div>
	);
};

const RatioDataPopover = ({ room }) => {
	const [anchorEl, setAnchorEl] = useState(null);
	const [selectedTab, setSelectedTab] = useState('student');
	const [hovered, setHovered] = useState(false);
	const isRoom = room?.room_type === 'room';

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};
	const handleChange = (event, newValue) => {
		setSelectedTab(newValue);
	};
	// sort the students by last name
	const sortedStudents = room?.ratios?.students?.sort((a, b) => {
		return a.last_name.localeCompare(b.last_name);
	});
	const sortedStaff = room?.ratios?.staff?.sort((a, b) => {
		return a.last_name.localeCompare(b.last_name);
	});
	return (
		<div className="flex flex-col gap-4">
			<button
				className={`flex justify-center items-center gap-4 font-bold text-black  border border-transparent rounded-full py-4 px-8 whitespace-nowrap ${
					hovered || Boolean(anchorEl) ? 'border-grey-300 shadow-sm' : ''
				}`}
				onClick={handleClick}
				onMouseEnter={() => setHovered(true)}
				onMouseLeave={() => setHovered(false)}
				type="button"
			>
				{isRoom ? (
					<>
						{room?.ratios.student_count} : {room?.ratios.staff_count}
					</>
				) : (
					room?.ratios.student_count
				)}
				<BsChevronDown className="text-black w-10" />
			</button>
			<Popover
				PaperProps={{ className: 'rounded-lg, h-320' }}
				anchorEl={anchorEl}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
				onClose={handleClose}
				open={Boolean(anchorEl)}
				transformOrigin={{ vertical: 'top', horizontal: 'left' }}
			>
				<div className="px-10 pt-4">
					<div className="sticky top-0 pt-4 bg-white z-99">
						<StyledTabs onChange={handleChange} value={selectedTab}>
							<StyledTab
								label={`${room?.ratios.student_count} student${room?.ratios.student_count > 1 ? 's' : ''}`}
								selected={selectedTab === 'student'}
								value="student"
							/>
							{isRoom ? (
								<StyledTab
									label={`${room?.ratios.staff_count} staff`}
									selected={selectedTab === 'staff'}
									value="staff"
								/>
							) : null}
						</StyledTabs>
					</div>
					{selectedTab === 'student' ? <CheckedInList people={sortedStudents} type="Students" /> : null}
					{selectedTab === 'staff' ? <CheckedInList people={sortedStaff} type="Staff" /> : null}
				</div>
			</Popover>
		</div>
	);
};

export default RatioDataPopover;
